import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow-y: auto;
`

export const TopInfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
`

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`

export const RightHeadContainer = styled.div`
  display: flex;
  gap: 10px;
  position: relative;
`

export const InstanceName = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${props => props.theme.text};
`

export const NavWrapper = styled.div`
  margin-top: 20px;
`

export const BodyWrapper = styled.div`
  margin-top: 20px;
`
